import { render, staticRenderFns } from "./noodKenB.vue?vue&type=template&id=71b090ca&scoped=true"
import script from "./noodKenB.vue?vue&type=script&lang=js"
export * from "./noodKenB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b090ca",
  null
  
)

export default component.exports